module.exports = __webpack_public_path__ + "static/79385157df3c5fc657bcbd74d2397835.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/features/branded-app.jpg
// module id = 1192
// module chunks = 0